import { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ExportToCSVButton } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';
import { showPlanDetails } from '@reducers/plan/plan';

const renderActionsCell = ({ row }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    id,
    plan_type: type,
    name,
    lt_available: outboundRates,
    country,
  } = row.original;
  const plan = {
    id,
    type,
    name,
    outboundRates,
  };
  return (
    <Button
      className="btn-sm"
      variant="didxl"
      onClick={() => {
        dispatch(showPlanDetails(plan));
        navigate(`/order/numbers?country=${country.id}`, {
          state: { fromCoverage: true },
        });
      }}
    >
      Info
    </Button>
  );
};

export const CoverageTable = ({ useData }) => {
  const [searchParams, _] = useSearchParams();

  const country = searchParams.get('country');
  const filterData = {
    country_id: country,
  };
  const exportContent = () => (
    <ExportToCSVButton
      to="customer/plans/coverage/export"
      filterData={filterData}
    />
  );
  const columns = useMemo(
    () => [
      { id: 'planID', Header: '', accessor: 'id' },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country.name',
      },
      { Header: 'TOS', accessor: 'type_of_service' },
      { Header: 'DID Type', accessor: 'type.name' },
      { Header: 'Plan', accessor: 'name' },
      { Header: 'Stock', accessor: 'stock' },
      { Header: 'Leadtime', accessor: 'leadtime', className: 'col-md-1' },
      {
        Header: 'Leadtime if no stock',
        accessor: 'leadtime_no_stock',
        className: 'col-md-1',
      },
      { Header: 'Porting', accessor: 'porting' },
      { Header: 'NRC', accessor: 'nrc' },
      { Header: 'MRC', accessor: 'mrc' },
      {
        id: 'action',
        Header: 'Action',
        className: 'col-md-1',
        Cell: renderActionsCell,
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Coverage</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          hiddenColumns="planID"
          exportContent={exportContent}
        />
      </Card.Body>
    </Card>
  );
};
